<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'SejarahTakaful',

    metaInfo: { title: 'Sejarah Takaful' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'about-us-detail',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
  }
</script>
